import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'localizedDate',
	pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
	constructor(private translateService: TranslateService) {}

	transform(value: any, pattern: string = 'medium'): any {
		const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
		let formattedDate = datePipe.transform(value, pattern);

		// Remove the timezone (anything like "GMT+X" or "UTC" at the end)
		formattedDate = formattedDate?.replace(/[\s\u00A0](GMT|UTC|[A-Z]{3,4})[^\d]*[\d:+-]*$/, '') || null;

		return formattedDate;
	}
}
